import {get, post} from '@/bank/bankApi.service'
import {CancelPaymentCommand, CancelPaymentResponse, InitiateExternalPaymentCommand, Payment, PaymentBasket} from '@/bank/bank.types'
import {computed, ref} from 'vue'
import {ExtendedPendingTransaction, PendingTransaction} from '@/pending-transaction/pendingTransaction.types'
import {suppliers} from '@/subaccount/subAccount.service'
import {getPendingTransactions} from '@/pending-transaction/pendingTransaction.service'
import _ from 'lodash'

const initiateExternalPayment = (cmd: InitiateExternalPaymentCommand): Promise<PaymentBasket> => post('/payments/payment-basket/initiate', cmd)
const cancelPayment = (cmd: CancelPaymentCommand): Promise<CancelPaymentResponse> => post('/payments/:cancel-payment', cmd)
const getPaymentsByUuids = (paymentUuids: string[]): Promise<Payment[]> => post('/payments/:get-by-uuids', paymentUuids)

const getPaymentBasket = async (paymentBasketUuid: string): Promise<PaymentBasket> => get(`/payments/payment-basket/${paymentBasketUuid}`)

const usePendingPayments = () => {
    const showCompleted = ref<boolean>(false)
    const payments = ref<Payment[]>([])
    const pendingTransactions = ref<PendingTransaction[]>([])
    const extendedPendingTransactions = computed<Array<ExtendedPendingTransaction>>(() => {
        return pendingTransactions.value.filter(p => showCompleted.value || p.status.toLowerCase() != 'complete')
            .map(pendingTransaction => {
                const payment = payments.value.find(payment => payment.uuid === pendingTransaction.paymentUuid)
                return {
                    ...pendingTransaction,
                    creditSubAccountName: suppliers.value.find(supplier => supplier.uuid === pendingTransaction.creditSubAccountUuid)?.name ?? '',
                    debitSubAccountName: suppliers.value.find(supplier => supplier.uuid === pendingTransaction.debitSubAccountUuid)?.name ?? '',
                    creditBankAccountNumber: payment?.senderAccountNumber ?? '',
                    debitBankAccountNumber: payment?.receiverAccountNumber ?? '',
                    paymentStatus: payment?.status ?? pendingTransaction.paymentStatus
                }
            })
    })

    const fetch = async () => {
        const pending = await getPendingTransactions()
        pendingTransactions.value = _.orderBy(pending, ['date', 'paymentStatus']).reverse()
        payments.value = await getPaymentsByUuids(pendingTransactions.value.map(pendingTransaction => pendingTransaction.paymentUuid))
    }

    return {
        fetch,
        showCompleted,
        payments,
        pendingTransactions,
        extendedPendingTransactions
    }
}

export {
    initiateExternalPayment,
    getPaymentBasket,
    getPaymentsByUuids,
    cancelPayment,
    usePendingPayments
}
